import React from 'react'
import clinqo from '../../assets/ClinqoWhite.svg'

export const WhyUs = ({ whyUsRef }) => {
    return (
        // This is the why us section
        <div className='px-[5vw] py-20 w-full bg-white' ref={whyUsRef}>
            {/* // This is the title */}
            <h2 className='text-3xl text-blue-500 font-semibold'>Why Us?</h2>
            <div className='mt-5 w-full flex flex-wrap justify-between items-center gap-3 h-full'>
                {/* // This is the description */}
                <div className='w-[45%] max-lg:w-[90%] text-base'>
                    <p className=''>
                        Clinqo is made to be the Ultimate Choice of Healthcare professionals and we realize and understand their needs. We are committed to the problems of our Customers and work hard to Solve them.
                    </p>
                    <p className='mt-3'>
                        Furthermore, our Values and Goals are for the improvement of the Whole Healthcare Ecosystem of India and we are just at the beginning of our journey.
                    </p>
                    <p className='mt-3'>
                        Be with us to pave the future of the Products in India.
                    </p>
                </div>
                {/* // This is the image */}
                <img className='w-[40%] max-lg:w-[90%] rounded-xl ]' src={clinqo} alt="Clinqo Logo" />
            </div>
        </div>
    )
}
